<template>
    <ExcelUpload class="mt-16" @uploaded="addOrganisation" showCard="organisation"></ExcelUpload>
</template>
<script>
import ExcelUpload from '../ExcelUpload.vue';
import clientDetailsService from '@/api/service/ClientDetails/ClientDetailsService';
export default {
    components:{
        ExcelUpload
    },
    data() {
        return {
            data: []
        }
    },
    methods: {
        async addOrganisation($data) {
            console.log($data,"$data!!")
            if ($data && $data.length > 0) {
                for (let i of $data) {
                    console.log(i,'iiiii')
                    const $insertData = {
                        "collectionName": "organisation",
                        "data": {
                            "organisationName": i?.Organisations?.[0]?.organisation_name || i?.organisation_name || '',
                            "logo": "",
                            "organisationType": i?.Organisations?.[0]?.organisation_type || i?.organisation_type || '',
                            "client": {},

                            "locations": [],
                            "organisation": {
                                "executive_management": [],
                                "sales_person": [],
                                "product_owners": []
                            },

                            "teams": {
                                "csr_leads": [],
                                "process_lead": [],
                                "process_associate": []
                            },
                            "web": "",

                            "emails": [
                                {
                                    "emailType": "",
                                    "email": ""
                                }
                            ],

                            "social-media": [
                                {
                                    "media": "",
                                    "handle": ""
                                }
                            ],

                            "executive-management": [
                                {
                                    "firstName": "",
                                    "lastName": "",
                                    "middleName": "",
                                    "name": "",
                                    "mobile": "",
                                    "email": "",
                                    "timezone": "",
                                    "imageUrl": "",
                                    "reachable": "",
                                    "timings": "",
                                    "fixed-timings": [
                                        {
                                            "slot": "",
                                            "from": "",
                                            "to": ""
                                        }
                                    ]
                                }
                            ],

                            "contacts": [
                                {
                                    "firstName": "",
                                    "lastName": "",
                                    "contactType": "",
                                    "middleName": "",
                                    "name": "",
                                    "mobile": "",
                                    "email": "",
                                    "timezone": "'",
                                    "imageUrl": "",
                                    "reachable": "",
                                    "timings": "",
                                    "fixed-timings": [
                                        {
                                            "slot": "",
                                            "from": "",
                                            "to": ""
                                        }
                                    ]
                                }
                            ],

                            "externalIds": [
                                {
                                    "organisationId": "",
                                    "networkType": ""
                                }
                            ],
                            "customers": i.Customers,
                            "exceptions": i.Exceptions,
                            "factories": i.Factories,
                            "shipping" : i.Shipping
                        }
                    };

                    // console.log($insertData,"$insertData")
                    await clientDetailsService.create($insertData)
                }
                this.$router.push('/')
            }
        },
    }
}
</script>